import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".hero-carousel-swiper").forEach((element) => {
    const loopCarousel = element.dataset.loop == "1";
    const autoplay = element.dataset.autoplay == "1";
    const autoplayDelay = parseFloat(element.dataset.autoplayDelay) * 1000 || 5000;

    // Track slides manually paused by the user so resize/slide-change won't restart them
    const manuallyPausedSlides = new Set();

    const swiper = new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loopCarousel,
      navigation: {
        enabled: element.dataset.navigation == "1",
        prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
        nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
      },
      pagination: {
        enabled: element.dataset.pagination == "1",
        el: element.closest(".swiper-parent").querySelector(".swiper-pagination"),
        clickable: true,
      },
      autoplay: autoplay
        ? { delay: autoplayDelay, disableOnInteraction: false }
        : false,
      on: {
        slideChange: (swiper) => {
          handleSlideChange(swiper);
        },
        afterInit: (swiper) => {
          handleSlideChange(swiper);
        },
      },
    });

    /**
     * Play video on active slide, pause on inactive slides.
     * Uses swiper.activeIndex directly — more reliable than checking CSS classes,
     * which may not be applied yet when slideChange fires.
     */
    function handleSlideChange(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];

      swiper.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (!video) return;

        if (slide === activeSlide) {
          if (!manuallyPausedSlides.has(slide)) {
            video.play().catch(() => {});
            syncPlayPauseButton(slide, false);
          }
        } else {
          video.pause();
          manuallyPausedSlides.delete(slide);
          syncPlayPauseButton(slide, true);
        }
      });
    }

    /**
     * Update the play/pause button state.
     * @param {Element} slide
     * @param {boolean} isPaused
     */
    function syncPlayPauseButton(slide, isPaused) {
      const btn = slide.querySelector(".hero-carousel-play-pause");
      if (!btn) return;

      const pauseContent = btn.querySelector(".pause-content");
      const playContent = btn.querySelector(".play-content");

      if (isPaused) {
        pauseContent?.classList.add("hidden");
        playContent?.classList.remove("hidden");
        btn.setAttribute("aria-label", btn.dataset.labelPlay || "Play video");
      } else {
        pauseContent?.classList.remove("hidden");
        playContent?.classList.add("hidden");
        btn.setAttribute("aria-label", btn.dataset.labelPause || "Pause video");
      }
    }

    // Attach click handlers to all play/pause buttons
    element.querySelectorAll(".hero-carousel-play-pause").forEach((btn) => {
      btn.addEventListener("click", () => {
        const slide = btn.closest(".swiper-slide");
        const video = slide?.querySelector("video");
        if (!video) return;

        if (video.paused) {
          video.play().catch(() => {});
          syncPlayPauseButton(slide, false);
          manuallyPausedSlides.delete(slide);
          if (autoplay) swiper.autoplay.start();
        } else {
          video.pause();
          syncPlayPauseButton(slide, true);
          manuallyPausedSlides.add(slide);
          if (autoplay) swiper.autoplay.stop();
        }
      });
    });
  });
});
